'use strict';

var Ignore = require('./ignore');

var internals = {};

module.exports = function () {
  return new Promise(Ignore); // $lab:coverage:ignore$
};